import { render, staticRenderFns } from "./KeyCup.vue?vue&type=template&id=5c1831ca&scoped=true"
import script from "./KeyCup.vue?vue&type=script&lang=js"
export * from "./KeyCup.vue?vue&type=script&lang=js"
import style0 from "./KeyCup.vue?vue&type=style&index=0&id=5c1831ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1831ca",
  null
  
)

export default component.exports